import { Chip } from '@mui/material';

const today = new Date();
export const renderRowCreatedAt = (locale, value = today, onlyDatePicker = true) => {
  const formatedDate = new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    ...(!onlyDatePicker && {
      hour: '2-digit',
      minute: '2-digit',
    }),
  })
    .format(new Date(value))
    .toString();
  return formatedDate;
};

export const renderRowStatus = (status) => {
  switch (status) {
    case 0:
      return <Chip label="در حال ایجاد" color="warning" sx={{ width: 100 }} />;
    case 1:
      return <Chip label="در حال ایجاد" color="warning" sx={{ width: 100 }} />;
    case 2:
      return <Chip label="پیش نویس" color="warning" sx={{ width: 100 }} />;
    case 3:
      return <Chip label="فعال" color="success" sx={{ width: 100 }} />;
    case 4:
      return <Chip label="غیر فعال" color="error" sx={{ width: 100 }} />;
    case 5:
      return <Chip label="آرشیو" color="error" sx={{ width: 100 }} />;

    default:
      break;
  }
};
